import { Button, Col, Form, Modal } from "react-bootstrap";
import {
    ButtonRemover, ButtonTrash, ButtonVisualizar, JRow, JTable, JTBody, JTHead, SpanIcon
} from "../../../../components/Components";
import { TypeUnidadesCargaVazia } from "../../../../lists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes, faDoorClosed, faPlus, faTags } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { InfUnidCargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { formatMoeda, getUuidV4, goToFocus } from "../../../../utils/utils";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { RE56 } from "../../../../utils/regex";
import { useDispatch, useSelector } from "react-redux";
import {
    addUnidadeCargaUnidadeTransporteNFe, removeUnidadeCargaUnidadeTransporteNFe,
    removeUnidadeCargaUnidadeTransporteNFeTodos
} from "../../../../features/manifestoSlice";
import { RootState } from "../../../../app/store";
import NFesUnidadeTranspUnidadeCargaLacres from "./NFesUnidadeTranspUnidadeCargaLacres";

const initialForm: InfUnidCargaInterface = {
    id: 0,
    idunidcarga: '',
    qtdrat: 0,
    tpunidcarga: 1,
    lacUnidCarga: [],

};

interface formProps {
    id: number | string;
    idNFe: number | string;
    show: boolean;
    handleClose: () => void;
}

const NFesUnidadeTranspUnidadeCarga: React.FC<formProps> = ({ id, idNFe, show, handleClose }) => {
    const [form, setForm] = useState<InfUnidCargaInterface>(initialForm)
    const idunidcargaRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [showLacres, setShowLacres] = useState<boolean>(false);
    const [idUndCarga, setIdUndCarga] = useState<string | number>(0);
    const unidadesTransportes = useSelector((state: RootState) => state.manifesto.manifesto).infMunDescarga
        .flatMap(mun => mun.infNFe).filter(nfe => nfe?.id?.toString() === idNFe.toString())
        .flatMap(ut => ut?.infUnidTransp).filter(f => f?.id.toString() === id.toString())
        .flatMap(ut => ut?.infUnidCarga ?? []);

    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');

    const handleCloseLacres = () => {
        setShowLacres(false);
        setSelecionado('');
    }

    const handleShowLacres = (id: number | string) => {
        setIdUndCarga(id);
        setShowLacres(true);
        setSelecionado(id);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const validaPreenchimento = () => {
        if (form.idunidcarga.toString().trim() === "") {
            goToFocus(idunidcargaRef);
            alertModal("Informe o identificador");
            return false;
        }

        if (unidadesTransportes.find(item => item.idunidcarga === form.idunidcarga &&
            item.tpunidcarga.toString() === form.tpunidcarga.toString())) {
            goToFocus(idunidcargaRef);
            alertModal("Identificador já adicionado para o tipo informado.");
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addUnidadeCargaUnidadeTransporteNFe({
                nfeId: idNFe,
                idUnidadeTransprte: id,
                data: {
                    ...form,
                    id: getUuidV4()
                }
            }))

            goToFocus(idunidcargaRef)

            setForm({
                ...initialForm,
                lacUnidCarga: []
            });
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {

            dispatch(removeUnidadeCargaUnidadeTransporteNFe({
                id: value.id,
                idUnidadeTransprte: id,
                nfeId: idNFe
            }));
        }
        setSelecionado('');
    }

    const handleRemoverTudo = async () => {
        if (unidadesTransportes.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todas as unidades de carga ?</>,
                title: "Confirmação"
            });

            if (confirmed) {
                dispatch(removeUnidadeCargaUnidadeTransporteNFeTodos({
                    idUnidadeTransprte: id,
                    nfeId: idNFe
                }))
            }
        }
    }

    useEffect(() => {
        setForm({
            ...initialForm,
            lacUnidCarga: []
        });
    }, [])

    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' size="lg"
            animation
            fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton className="py-2 bg-success">
                <Modal.Title>
                    <FontAwesomeIcon icon={faBoxes} className="me-1" />Unidades de Carga
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <JRow className="mb-3 pe-2 ">
                    <Col md>
                        <Form.Group controlId="nfe-uc-tpunidcarga">
                            <Form.Label>Tipo Unid. Carga</Form.Label>
                            <Form.Select name="tpunidcarga" onChange={handleChange}
                                value={form.tpunidcarga} autoComplete="false"
                            >
                                {TypeUnidadesCargaVazia.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-uc-idunidcarga">
                            <Form.Label>* Identificação</Form.Label>
                            <Form.Control type="text" name="idunidcarga" maxLength={20} value={form.idunidcarga}
                                ref={idunidcargaRef}

                                onChange={(e: any) => {
                                    setForm({
                                        ...form,
                                        [e.target.name]: e.target.value.replace(RE56, '')
                                    })

                                }} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-uc-qtdrat">
                            <Form.Label>Rateio</Form.Label>
                            <Form.Control type="number" name="qtdrat" min={0} value={form.qtdrat}

                                onChange={(e) => {
                                    const { name, value } = e.target;
                                    setForm({
                                        ...form,
                                        [name]:
                                            value.replace(/[^0-9.]/g, "")
                                                .replace(/^(\d{0,3})\d*/, "$1")
                                                .replace(/(\.\d{3})\d+/, "$1")
                                    })
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button variant="primary" onClick={handleAdd} >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>
                </JRow>

                <JTable >
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTudo()} />

                            </th>
                            <th>Tipo Unid. Carga</th>
                            <th>Identificador</th>
                            <th>Qtd. Rateio</th>
                            <th style={{ width: '4.5rem' }} className="text-center">Lacres</th>
                        </tr>
                    </JTHead>
                    <JTBody>

                        {unidadesTransportes.map(item => {
                            return (
                                <tr key={item?.id}
                                    className={(item.id.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="text-center d-flex justify-content-around">
                                        <ButtonRemover onClick={() =>
                                            handleRemover({ id: item?.id ?? '', title: item?.idunidcarga ?? '' })
                                        } />

                                    </td>
                                    <td>
                                        {TypeUnidadesCargaVazia.find((i) => (
                                            i.id.toString() === item?.tpunidcarga.toString()
                                        ))?.name
                                        }
                                    </td>
                                    <td>{item?.idunidcarga}</td>
                                    <td>{formatMoeda(item?.qtdrat ?? 0, 3, "decimal")}</td>
                                    <td className="text-center">
                                        <ButtonVisualizar icon={faTags} onClick={() => handleShowLacres(item.id)} title="Lacres">
                                            <SpanIcon count={item.lacUnidCarga?.length ?? 0} />
                                        </ButtonVisualizar>

                                    </td>
                                </tr>
                            )
                        })
                        }

                    </JTBody>
                </JTable>
            </Modal.Body>

            <Modal.Footer className="py-2">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>

        <NFesUnidadeTranspUnidadeCargaLacres
            show={showLacres}
            handleClose={handleCloseLacres}
            id={id}
            idUndCarga={idUndCarga}
            idNFe={idNFe}
        />

        {ConfirmModal}
        {ModalMessageEl}

    </>)
}

export default NFesUnidadeTranspUnidadeCarga;